import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const WhatsAppButton = ({ product, className = "" }) => {
  const phoneNumber = "919030792052";
  
  const generateMessage = () => {
    const message = `🔮 Hi! I'm interested in ordering:

*${product.name}*
Price: ₹${product.price}
Category: ${product.category === 'healing' ? '✧ Healing Crystal' : '◆ Raw Stone'}

Please let me know about availability and delivery details. ✨`;
    
    return encodeURIComponent(message);
  };

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${generateMessage()}`;
    window.open(url, '_blank');
  };

  return (
    <Button
      onClick={handleClick}
      className={`bg-whatsapp hover:bg-whatsapp/90 text-white rounded-full px-8 py-6 text-base font-medium whatsapp-pulse btn-lift ${className}`}
      data-testid="whatsapp-order-btn"
    >
      <MessageCircle className="w-5 h-5 mr-2" />
      Order via WhatsApp
    </Button>
  );
};

export default WhatsAppButton;
